
export const InternalImageMultigetQuery = new TypedDocumentString(`
    query InternalImageMultigetQuery($input: [String!]!) {
  internalImageMultiget(input: $input) {
    key
    image {
      ...Image
      __typename
    }
    __typename
  }
}
    fragment DocumentColorHsla on DocumentColorHsla {
  h
  s
  l
  a
  __typename
}
fragment ImageNodeItem on ImageNodeItem {
  _id
  alt
  uploadDate
  type
  url
  fallbackUrl
  img
  height
  width
  noProxy
  hsla {
    ...DocumentColorHsla
    __typename
  }
  aspect {
    x
    y
    __typename
  }
  audio
  videoHls
  video
  isVideo
  __typename
}
fragment Image on Image {
  alt {
    value
    __typename
  }
  isVideo
  image2 {
    ...ImageNodeItem
    __typename
  }
  __typename
}`, {"hash":"e821e4c520933eb1517f2f2c91b843f695b650a7cd48c779d7bfc3abdac8e4a2"});